import { MaturityDateTypeGql, PayPatternGql, PaymentRuleEventGql } from "@/graphql/codegen/graphql"

export const PAYMENT_RULE_EVENT_OPTIONS = [
  {
    label: "Delivery",
    value: PaymentRuleEventGql.Delivery,
  },
  {
    label: "End of invoice month",
    value: PaymentRuleEventGql.EndOfInvoiceMonth,
  },
  {
    label: "Placing order",
    value: PaymentRuleEventGql.PlacingOrder,
  },
  {
    label: "Shipping",
    value: PaymentRuleEventGql.Shipping,
  },
]

export const PAY_PATTERN_LABELS: Record<PayPatternGql, string> = {
  [PayPatternGql.BiWeekly]: "Biweekly",
  [PayPatternGql.Monthly]: "Monthly",
  [PayPatternGql.Weekly]: "Weekly",
}

export const PAY_INVOICE_LABELS: Record<MaturityDateTypeGql, string> = {
  [MaturityDateTypeGql.CalendarPeriod]: "Calendar Period",
  [MaturityDateTypeGql.PayInterval]: "Pay Interval",
}

export const MAX_ALLOWED_OPTIONS = 5
export const MAX_ALLOWED_PARTS = 5
export const AMOUNT_OF_BI_WEEKLY_DAYS = 14

export const PAY_RUN_PREVIEW_WEEKLY_DAYS = ["M", "Tu", "W", "Th", "F", "Sa", "Su"]
export const PAY_RUN_PREVIEW_AMOUNT_OF_BI_WEEKLY_DAYS = 28
export const PAY_RUN_PREVIEW_AMOUNT_OF_MONTHLY_DAYS = 31
